import { useState, useEffect, useCallback } from "react";
import { contactsService } from "@/api/services/contacts.service";
export function useGhlBusinesses() {
    const [state, setState] = useState({
        businesses: [],
        loading: true,
        error: null,
    });
    const fetchBusinesses = useCallback(async () => {
        setState((prev) => ({ ...prev, loading: true, error: null }));
        try {
            const response = await contactsService.getGHLBusinesses();
            setState({
                businesses: response.data.data,
                loading: false,
                error: null,
            });
        }
        catch (err) {
            setState((prev) => ({
                ...prev,
                loading: false,
                error: err instanceof Error ? err.message : "Failed to load GHL businesses",
            }));
        }
    }, []);
    useEffect(() => {
        fetchBusinesses();
    }, [fetchBusinesses]);
    return {
        ...state,
        refetch: fetchBusinesses,
    };
}
